module.exports = __webpack_public_path__ + "img/bebidas.c72f3f18.jpg";